import React, { useState, useEffect } from 'react';
import jeuImage from './images/Monopoly2x2.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons'; 
import "bootstrap-icons/font/bootstrap-icons.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Dado from './Dado';
import { meualteradoProvider, useAlteradoContext } from './AlteradoProvider';
import { Nav, Button } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import './Menu.css';


const Menu = () => {
 
  const { mostrarDado } = useAlteradoContext();
  const [dropdownMenu, setDropdownMenu] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  
  const location = useLocation();

 

/*     console.log("dado teste",mostrarDado)
 */const handleButtonDropDown = ()=> {
  if (dropdownMenu){
    setDropdownMenu(false)
  }else{
    setDropdownMenu(true);
  }
  
}

return (
    <div className='menu-container'>

  <div className='menu-nav'>
    <div className='menu-novo'>
   <Nav>
          <Nav.Link
          as={Link}
         to="/"
          className={`navlink ${location.pathname === '/' ? 'active-link' : ''}`}
          onClick={(e) => {
          if (location.pathname === '/') {
            e.preventDefault(); 
          }
        }} 
      >
        Projet
      </Nav.Link>
 
      <Nav.Link
          as={Link}
         to="/quiz"
          className={`navlink ${location.pathname === '/quiz' ? 'active-link' : ''}`}
          onClick={(e) => {
          if (location.pathname === '/quiz') {
            e.preventDefault(); 
          }
        }}
      >
        Quiz
      </Nav.Link>

      <Nav.Link
        as={Link}
        to="/associations"
        className={`navlink ${location.pathname === '/associations' ? 'active-link' : ''}`}
        onClick={(e) => {
          if (location.pathname === '/associations') {
            e.preventDefault(); 
          }
        }}
      >
        Associations
      </Nav.Link>
      <Nav.Link
        as={Link}
        to="/outils"
        className={`navlink ${location.pathname === '/outils' ? 'active-link' : ''}`}
        onClick={(e) => {
          if (location.pathname === '/outils') {
            e.preventDefault(); 
          }
        }}
      >
        Outils
      </Nav.Link>
      <Nav.Link
        as={Link}
        to="/contact"
        className={`navlink ${location.pathname === '/contact' ? 'active-link' : ''}`}
        onClick={(e) => {
          if (location.pathname === '/contact') {
            e.preventDefault(); 
          }
        }}
      >
        Contact
      </Nav.Link>
      <div id='dado-menu'>
{mostrarDado && (
 <Dado></Dado>
)}
 
</div>   
</Nav>
</div>
</div>

       <div className='dropdown-menu-novo'>
         
        <button className='dropdown-button' onClick={handleButtonDropDown}><FontAwesomeIcon icon={faBars} className='dropdown-button-icon' /></button>
       
       {showMenu ? dropdownMenu : !showMenu}
       
        {dropdownMenu &&  (
        <div className='menu-palete'>
      

          <Nav>
          <Nav.Link
          as={Link}
         to="/"
          className={`navlink ${location.pathname === '/' ? 'active-link' : ''}`}
          onClick={(e) => {
          if (location.pathname === '/') {
            e.preventDefault(); 
          }
        }} 
      >
        Projet
      </Nav.Link>
 
      <Nav.Link
          as={Link}
         to="/quiz"
          className={`navlink ${location.pathname === '/quiz' ? 'active-link' : ''}`}
          onClick={(e) => {
          if (location.pathname === '/quiz') {
            e.preventDefault(); 
          }
        }}
      >
        Quiz
      </Nav.Link>

      <Nav.Link
        as={Link}
        to="/associations"
        className={`navlink ${location.pathname === '/associations' ? 'active-link' : ''}`}
        onClick={(e) => {
          if (location.pathname === '/associations') {
            e.preventDefault(); 
          }
        }}
      >
        Associations
      </Nav.Link>
      <Nav.Link
        as={Link}
        to="/outils"
        className={`navlink ${location.pathname === '/outils' ? 'active-link' : ''}`}
        onClick={(e) => {
          if (location.pathname === '/outils') {
            e.preventDefault(); 
          }
        }}
      >
        Outils
      </Nav.Link>
      <Nav.Link
        as={Link}
        to="/contact"
        className={`navlink ${location.pathname === '/contact' ? 'active-link' : ''}`}
        onClick={(e) => {
          if (location.pathname === '/contact') {
            e.preventDefault(); 
          }
        }}
      >
        Contact
      </Nav.Link>


{/*           <div id='dado-menu'>{mostrarDado && (<Dado></Dado>)} </div>
 */}</Nav>
              </div>
          )}
   
     
       </div>
     
   
    </div>
    

    
  );
};

export default Menu;